<template lang="pug">

.thousands
  .thousands-intro.u-section-full.u-section-padding.u-textCenter
    h1.u-mb-xm {{$t('mantra')}}
    h5.u-mb-xs {{$t('mantra')}}
    p.u-mb-xs {{$t('mantraDesc1')}}
    p.u-mb-sm {{$t('mantraDesc2')}}
    img.thousands-intro-img(src='https://cdn.baianat.com/static/resources/thousands/2.png', srcset='https://cdn.baianat.com/static/resources/thousands/2.png 1x, https://cdn.baianat.com/static/resources/thousands/2@2x.png 2x')


  section.thousands-numbers.u-section-full.u-section-padding.u-textCenter
    h2 + 2000
    p.u-text-lg {{$t('freeBundle')}}
    img.u-mh-xm(src='https://cdn.baianat.com/static/resources/thousands/3.png', srcset='https://cdn.baianat.com/static/resources/thousands/3.png 1x, https://cdn.baianat.com/static/resources/thousands/3@2x.png 2x')
    AppLink(to="https://baianat.com/files/file10ziw1jr663iud" class="button is-rounded is-wide is-white") {{$t('download')}}

  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-middle
          .column.is-desktop-7.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/thousands/4.png', srcset='https://cdn.baianat.com/static/resources/thousands/4.png 1x, https://cdn.baianat.com/static/resources/thousands/4@2x.png 2x')
          .column.is-desktop-5.u-mb-sm
            h4 {{$t('coloredIcons')}}
            p {{$t('coloredIconsDesc')}}
          .column.is-desktop-5.u-mb-sm
            h4 {{$t('wiredIcons')}}
            p {{$t('wiredIconsDesc')}}
          .column.is-desktop-7.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/thousands/5.png', srcset='https://cdn.baianat.com/static/resources/thousands/5.png 1x, https://cdn.baianat.com/static/resources/thousands/5@2x.png 2x')

  section.thousands-package.u-section-full.u-section-padding.u-textCenter
    h2 + 2000
    p.u-text-lg.u-mb-sm {{$t('bigFree')}}
    img.thousands-package-img(src='https://cdn.baianat.com/static/resources/thousands/6.png', srcset='https://cdn.baianat.com/static/resources/thousands/6.png 1x, https://cdn.baianat.com/static/resources/thousands/6@2x.png 2x')

  section.thousands-cats.u-section-full.u-section-padding
    .grid.is-middle
      .column.is-desktop-7.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/thousands/7.png', srcset='https://cdn.baianat.com/static/resources/thousands/7.png 1x, https://cdn.baianat.com/static/resources/thousands/7@2x.png 2x')
      .column.is-desktop-5.u-mb-md
        h4 {{$t('categories')}}
        p {{$t('categoriesDesc')}}

      .column.is-desktop-5.u-mb-sm
        h4 {{$t('emotions')}}
        p {{$t('emotionsDesc')}}
      .column.is-desktop-7.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/thousands/8.png', srcset='https://cdn.baianat.com/static/resources/thousands/8.png 1x, https://cdn.baianat.com/static/resources/thousands/8@2x.png 2x')

  section.u-section-full.u-section-padding.u-textCenter.u-mh-lg
    h2 + 400
    p.u-mb-sm {{$t('coloredWired')}}
    img.u-img(src='https://cdn.baianat.com/static/resources/thousands/9.png', srcset='https://cdn.baianat.com/static/resources/thousands/9.png 1x, https://cdn.baianat.com/static/resources/thousands/9@2x.png 2x')

  section.thousands-who.u-section-full.u-section-padding
    h4.u-mb-xm {{$t('whoBenefits')}}
    .grid.is-desktop-4
      .column.u-mb-sm
        h5 {{$t('designers')}}
        p {{$t('designersDesc')}}
      .column.u-mb-sm
        h5 {{$t('developers')}}
        p {{$t('developersDesc')}}
      .column.u-mb-sm
        h5 {{$t('details')}}
        p(v-for="item in $t('detailsItems')") {{item}}

    img(src='https://cdn.baianat.com/static/resources/thousands/10.png', srcset='https://cdn.baianat.com/static/resources/thousands/10.png 1x, https://cdn.baianat.com/static/resources/thousands/10@2x.png 2x')

  section.thousands-features.u-section-full.u-section-padding
    .grid.is-desktop-4
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/thousands/11.png', srcset='https://cdn.baianat.com/static/resources/thousands/11.png 1x, https://cdn.baianat.com/static/resources/thousands/11@2x.png 2x')
        h4.u-mh-xs {{$t('resizable')}}
        p {{$t('resizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/thousands/12.png', srcset='https://cdn.baianat.com/static/resources/thousands/12.png 1x, https://cdn.baianat.com/static/resources/thousands/12@2x.png 2x')
        h4.u-mh-xs {{$t('customizable')}}
        p {{$t('customizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/thousands/13.png', srcset='https://cdn.baianat.com/static/resources/thousands/13.png 1x, https://cdn.baianat.com/static/resources/thousands/13@2x.png 2x')
        h4.u-mh-xs {{$t('unlimited')}}
        p {{$t('unlimitedDesc')}}


  section.thousands-cta.u-section-full.u-section-padding.u-textCenter
    AppTitle.u-mb-xm(:title="$t('cta')" tag="h2")

    p.u-mb-xm {{$t('ctaDesc')}}

    AppLink(to="https://baianat.com/files/file10ziw1jr663iud" class="button is-rounded is-wide is-white" :title="$t('download')") {{$t('download')}}


</template>

<style lang="stylus">
$clMain = #e7be33
$clBlue = #2476ff
$clDark = #142a3b
$clYellow = #e7be33
$clGreen = #0cb04a
$clDark2 = #122533

div.app.is-thousands
  overflow: hidden

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

  .footer
    border-top: none

.thousands
  position: relative
  z-index: 1

  &-intro
    background-color: $clMain
    color: $clWhite
    padding-top: unitRes(200, 300)
    padding-bottom: 0
    z-index: 1
    position: relative
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)
    background: url('https://cdn.baianat.com/static/resources/thousands/1@2x.png') no-repeat top center fixed $clMain

    &-img
      margin-bottom: -300px

      +mq($until: 'desktop')
        margin-bottom: -30%

  &-numbers
    background-color: rgba(130, 98, 181, 0.902)
    padding-top: 100px
    padding-bottom: 100px
    color: $clWhite
    position: relative
    z-index: 2

  &-package
    background: $clYellow
    color: $clWhite
    padding-top: unitRes(100, 200)

    &-img
      margin-bottom: -300px

      +mq($until: 'desktop')
        margin-bottom: -30%

  &-cats
    background: #8262b5
    color: $clWhite
    padding-top: 400px
    padding-bottom: unitRes(100, 200)

    +mq($until: 'desktop')
      padding-top: 40%

  &-who
    background: #e56a77
    color: $clWhite
    padding-top: unitRes(80, 160)
    padding-bottom: unitRes(80, 160)

  &-features
    background-color: $clYellow
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(50, 150)

  &-cta
    background: #8262b5
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-thousands   is-whiteHeader is-fixedHeader',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Thousands Icons",
    "pageDesc":"Express meanings with less text using thousands icons set that can be customized to fit in every design layout and context.",
    "mantra":"Colored - Wired Icons",
    "mantraDesc1":"Download 2000 ICONS in PSD, AI & Sketch .",
    "mantraDesc2":"Enjoy thousand icons in different background colors that give your #[br] designs a special look.",
    "freeBundle":"Free icon bundle in four formats",
    "download":"Download",
    "coloredIcons":"Colored icons",
    "coloredIconsDesc":"Enjoy Thousand icons with its different retro color mood, that gives your designs a special look.",
    "wiredIcons":"Wired icons",
    "wiredIconsDesc":"Use thousand icons in wired colorless style for clear and simple designs.",
    "bigFree":"Thousands is a big free icons package",
    "categories":"20+ categories",
    "categoriesDesc":"Enjoy more than 20 different categories covering many design areas.",
    "emotions":"And also Emotions",
    "emotionsDesc":"Find all the emoticons you need in one category.",
    "coloredWired":"Colored and wired interactive icons",
    "whoBenefits":"Who benefits",
    "designers":"Designers",
    "designersDesc":"Enjoy Thousands icons on any platform you are using, PSD, AI, Sketch or even PNG.",
    "developers":"Developers",
    "developersDesc":"SVG icons format are made for you to serve and facilitate your work process.",
    "details":"Details",
    "detailsItems":{
      "1":"Type: Colored + Wired",
      "2":"Format: Ai - PSD - Sketch - SVG",
      "3":"Count: 2000+",
      "4":"Size: 58 MB",
      "5":"Licence: Commercial"
    },
    "resizable":"Resizable",
    "resizableDesc":"To ensure Thousands icons perfection, sharpness and consistency, all of them are created on a grid of 64px.",
    "customizable":"Customizable",
    "customizableDesc":"Enjoy Thousands icons as much as you want, as you can customize its colors or sizes to what suits you.",
    "unlimited":"Unlimited Colors",
    "unlimitedDesc":"To fulfill all your design needs, Thousands icons come to you in two different styles, colored and wired.",
    "cta":"Thousands icons |bundle",
    "ctaDesc":"Enjoy a variety of thousands of icons in your designs"
  },
  "ar": {
    "pageTitle":"أيقونات ثاوزندز",
    "pageDesc":"التعبير عن المعاني باستخدام نصوص أقل من خلال آلاف الأيقونات المجانية التي يمكن تخصيصها لتتلائم سياق التصميم لمشروع مميز.",
    "mantra":"أيقونات ملونة - خطية",
    "mantraDesc1":"قم بتحميل 2000 ايقونة بصيغة PSD و AI و Sketch.",
    "mantraDesc2":"استمتع بألاف الأيقونات مع خلفيات ملونة التي تمنح تصميمك نظرة خاطفة.",
    "freeBundle":"أيقونات مجانية بأربعة تنسيقات",
    "download":"تحميل",
    "coloredIcons":"أيقونات ملونة",
    "coloredIconsDesc":"استمتع بالاف الأيقونات التي تتميز بوجود ألوان ريترو المختلفة والتي تمنح تصميمك بصمة فريدة.",
    "wiredIcons":"أيقونات خطية",
    "wiredIconsDesc":"استخدم آلاف الأيقونات الموجودة بشكلها الخطي  بدون الوان لتصاميم واضحة وبسيطة.",
    "bigFree":"ثاوزندز هي مجموعة كبيرة من الأيقونات المجانية",
    "categories":"20+ فئة",
    "categoriesDesc":"استمتع بأكثر من 20 فئة مختلفة تغطي جميع مجالات التصميم",
    "emotions":"الإيموجي",
    "emotionsDesc":"ابحث عن الإيموجي الذي تحتاجه في فئة واحدة.",
    "coloredWired":"أيقونات تفاعلية ملونة وخطية",
    "whoBenefits":"صممناها من أجل",
    "designers":"المصممون",
    "designersDesc":"تمتع بأيقونات ثاوزندز على أي نظام أساسي تستخدمه، بما في ذلك PS أو AI أو Sketch أو حتى PNG.",
    "developers":"المطورون",
    "developersDesc":"تم تصميم أيقونات SVG لتسهيل سير عملك وإنهائه في دقائق.",
    "details":"التفاصيل",
    "detailsItems":{
      "1":"النوع: ملون + خطي",
      "2":"التنسيق: Ai - PSD - Sketch - SVG",
      "3":"العدد: 2000+",
      "4":"الحجم: 58 MB",
      "5":"الترخيص: تجاري"
    },
    "resizable":"قابلة لتغيير حجمها",
    "resizableDesc":"لضمان تحقيق أيقونة ثاوزندز الكمال والاتساق، تم إنشاء جميع الأيقونات على شبكة بحجم 64 بكسل.",
    "customizable":"مخصصة",
    "customizableDesc":"استمتع بأيقونات ثاوزندز بالشكل الذي تريده حيث يمكنك تخصيص ألوانها وأحجامها بما يناسبك.",
    "unlimited":"ألوان غير محدودة",
    "unlimitedDesc":"لتحصل على كل ما يحتاجه تصميمك، تأتي أيقونات ثاوزندز بنمطين مختلفين، ملون وخطي.",
    "cta":"مجموعة أيقونات |ثاوزندز",
    "ctaDesc":"استمتع بمجموعة متنوعة من ألاف الأيقونات لتُلهمك في تصميماتك القادمة."
  }
}
</i18n>
